






















import {computed, defineComponent, ref, watch} from '@vue/composition-api';
import {Dialog} from '@mfex/mai-ui';
import {getAssetURL} from 'common/util';
import constant from 'common/constant';
import eventBus from 'common/event-bus';
import Cookies from 'js-cookie';

export default defineComponent({
    name: 'JumpTbDialog',
    components: {
        MaiDialog: Dialog.Component
    },
    setup() {
        const visible = ref(false); // 弹窗开关
        const allowAndNeverTip = ref(false); // 是否始终允许授权并不再提醒
        const checkboxImg = computed(() =>
            allowAndNeverTip.value ? getAssetURL('img/checkbox-sel.png') : getAssetURL('img/checkbox-unsel.png')
        );
        // 监听eventbus
        const tbDialogInfo = computed(() => eventBus.tbDialogInfo);
        watch(tbDialogInfo, val => {
            visible.value = val.visible;
        });
        // 允许授权
        const handleTbAllow = () => {
            const {jumpFunc} = tbDialogInfo.value;
            if (allowAndNeverTip.value) {
                const allowList = JSON.parse(localStorage.getItem(constant.ALLOW_TB)) || [];
                allowList.push(Cookies.get('user_id'));
                localStorage.setItem(constant.ALLOW_TB, JSON.stringify(allowList));
            }
            handleTbCancel();
            jumpFunc();
        };
        // 取消
        const handleTbCancel = () => {
            eventBus.tbDialogInfo.visible = false;
            allowAndNeverTip.value = false;
        };

        return {
            visible,
            allowAndNeverTip,
            checkboxImg,
            handleTbAllow,
            handleTbCancel
        };
    }
});
